import type { DocType } from '../../types/chat'

interface DocTypeStyle {
  bg: string
  text: string
  border: string
}

const NEUTRAL: DocTypeStyle = { bg: 'bg-muted', text: 'text-muted-foreground', border: 'border-border' }

const STYLES: Record<DocType, DocTypeStyle> = {
  hpi: { bg: 'bg-clinical-teal/10', text: 'text-clinical-teal', border: 'border-clinical-teal/30' },
  hp: { bg: 'bg-clinical-cyan/10', text: 'text-clinical-cyan', border: 'border-clinical-cyan/30' },
  soap: { bg: 'bg-clinical-sage/10', text: 'text-clinical-sage', border: 'border-clinical-sage/30' },
  assessment: { bg: 'bg-clinical-amber/10', text: 'text-clinical-amber', border: 'border-clinical-amber/30' },
  discharge: { bg: 'bg-primary/10', text: 'text-primary', border: 'border-primary/30' },
  consult: { bg: 'bg-clinical-coral/10', text: 'text-clinical-coral', border: 'border-clinical-coral/30' },
  ipass: NEUTRAL,
  custom: NEUTRAL,
  sweep: NEUTRAL,
  chart_sweep: NEUTRAL,
}

// Accepts known DocType values; unknown backend strings fall through to the neutral 'custom' style.
export const getDocTypeStyles = (type: DocType | string): DocTypeStyle => STYLES[type as DocType] ?? STYLES.custom
